// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"html5"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 2H21L20 19.5L12 22.5L4 19.5L3 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 2H21L20 19.5L12 22.5L4 19.5L3 2Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M16.5 6H17.2714L17.2709 6.00771L16.5 6ZM16.5 6H6.72852L7.03576 11.3768L11.2549 11.3768L16.9641 11.3768L16.6569 16.7537L12 18.5L7.34301 16.7536L7.2662 15.4094L7.2566 15.2414M7.2566 15.2414L7.24699 15.0734H7.25L7.2566 15.2414Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-html5')
export default class Html5Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'html5',
    }
  }
}
